export const neutral = {
  black: '#181331',
  grayLightest: '#cfcfcf',
  grayLighter: '#f4f4f5',
  grayLight: '#E5E5E5',
  gray: '#333333',
  grayDark: '#746f7f',
  grayDarker: '#2c253c',
  grayDarkest: '#2c243d',
  grayPale: '#A5A5A5',
  grayPaler: '#F5F5F5',
  white: '#ffffff',
  plainBlack: '#1C1B18',
  azureWithOpacity: (opacity) => `rgba(56, 227, 211, ${opacity})`,
  whiteWithOpacity: (opacity) => `rgba(255, 255, 255, ${opacity})`,
  blackWithOpacity: (opacity) => `rgba(24, 19, 49, ${opacity})`,
};

export const brand = {
  greenLight: '#2ae8c8',
  green: '#1BA500',
  greenDark: '#396044',
  greenDarkWithOpacity: (opacity) => `rgba(57, 96, 68, ${opacity})`,
  blueLight: '#549ACE',
  blue: '#0078D3',
  blueDark: '#022047',

  white: '#FFFFFF',
  azure: '#38E3D3',
  pink: '#D65FB2',
  purple: '#8E56C2',
  purpleLight: '#8E56C2',
  purpleDark: '#6F52C9',
  red: '#F36264',
  redDark: '#b81414',
  black: '#181331', // this color is named "Dark Purple" in the mockups
  gold: '#DCAA4F',
  yellowDark: '#FFE736',
  goldWithOpacity: (opacity) => `rgba(220, 170, 79, ${opacity})`,
};

export const brandIM = {
  yellow: '#FFE736',
  yellowDark: '#B2A125',
};

export const theme = {
  background: '#FFF',
  text: neutral.plainBlack,
  primary: brand.gold,
  secondary: brand.greenDark,
};

export const themeIM = {
  background:
    'linear-gradient(90deg, rgba(14,43,101,1) 0%, rgba(70,95,139,1) 100%)',
  text: neutral.white,
  textInv: neutral.black,
  primary: brandIM.yellow,
  secondary: brandIM.yellowDark,
};

// export const neutral = {
//   black: '#181331',
//   grayLightest: '#cfcfcf',
//   grayLighter: '#f4f4f5',
//   grayLight: '#E5E5E5',
//   gray: '#333333',
//   grayDark: '#746f7f',
//   grayDarker: '#2c253c',
//   grayDarkest: '#2c243d',
//   grayPale: '#A5A5A5',
//   grayPaler: '#F5F5F5',
//   white: '#ffffff',
//   plainBlack: '#1C1B18',
//   azureWithOpacity: (opacity) => `rgba(56, 227, 211, ${opacity})`,
//   whiteWithOpacity: (opacity) => `rgba(255, 255, 255, ${opacity})`,
//   blackWithOpacity: (opacity) => `rgba(24, 19, 49, ${opacity})`,
// };

// export const neutral2 = {
//   black: '#181331',
//   grayLightest: '#cfcfcf',
//   grayLighter: '#f4f4f5',
//   grayLight: '#E5E5E5',
//   gray: '#333333',
//   grayDark: '#746f7f',
//   grayDarker: '#2c253c',
//   grayDarkest: '#2c243d',
//   grayPale: '#A5A5A5',
//   grayPaler: '#F5F5F5',
//   white: '#ffffff',
//   plainBlack: '#1C1B18',
//   azureWithOpacity: (opacity) => `rgba(56, 227, 211, ${opacity})`,
//   whiteWithOpacity: (opacity) => `rgba(255, 255, 255, ${opacity})`,
//   blackWithOpacity: (opacity) => `rgba(24, 19, 49, ${opacity})`,
// };

export const ui = {
  accentPrimary: brand.purple,
  accentSecondary: brand.azure,
  backgroundGradientStart: '#17142f',
  backgroundGradientStop: '#3d3950',
  backgroundGray: '#D5D5D5',
  carissma: '#E87695',
  carissmaLight: '#DC82C0',
  danger: '#A20A0A',
  success: brand.azure,
  textLight: neutral.gray,
  text: neutral.grayDark,
  textDark: neutral.grayDarker,
  warning: '#fffabf',
  canvasBackground: '#d5d5d5',
};

export const linkColors2 = {
  violet: '#9400D3',
  indigo: '#4B0082',
  blue: '#0000FF',
  green: '#00FF00',
  yellow: '#FFFF00',
  orange: '#FF7F00',
  red: '#FF0000',
};

export const linkColors = [
  { value: 'rgba(0, 0, 0, 1)' },
  { value: 'rgba(158, 1, 66, 1)' },
  { value: 'rgba(213, 62, 79, 1)' },
  { value: 'rgba(244, 109, 67, 1)' },
  { value: 'rgba(253, 174, 97, 1)' },
  { value: 'rgba(254, 224, 139, 1)' },
  { value: 'rgba(230, 245, 152, 1)' },
  { value: 'rgba(171, 221, 164, 1)' },
  { value: 'rgba(102, 194, 165, 1)' },
  { value: 'rgba(50, 136, 189, 1)' },
  { value: 'rgba(94, 79, 162, 1)' },
  { value: brand.greenDark },
  { value: brand.white },
].map((v) => v.value);

export const riskColors = [
  { value: brand.redDark },
  { value: brand.red },
  { value: brand.yellowDark },
  { value: brand.green },
  { value: brand.greenDark },
  { value: brand.white },
].map((v) => v.value);
